import { render, staticRenderFns } from "./jugendschutz.vue?vue&type=template&id=57724df2&scoped=true&"
import script from "./jugendschutz.vue?vue&type=script&lang=ts&"
export * from "./jugendschutz.vue?vue&type=script&lang=ts&"
import style0 from "./jugendschutz.vue?vue&type=style&index=0&id=57724df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57724df2",
  null
  
)

export default component.exports